import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollExperience() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const positions = useRef(new Map<string, number>());
  useEffect(() => {
    const key = location.key;
    const target = navigationType === "POP" ? positions.current.get(key) ?? 0 : 0;
    let restoring = true;
    // eslint-disable-next-line prefer-const -- assigned after stop() closes over it
    let timer: ReturnType<typeof setTimeout>;
    const save = () => { if (!restoring) positions.current.set(key, window.scrollY); };
    const stop = () => { restoring = false; observer.disconnect(); clearTimeout(timer); };
    const restore = () => {
      if (!restoring) return;
      window.scrollTo({ top: target, behavior: "auto" });
      if (Math.abs(window.scrollY - target) <= 1) stop();
    };
    const observer = new ResizeObserver(restore);
    observer.observe(document.body);
    timer = setTimeout(stop, 5000);
    const frame = requestAnimationFrame(restore);
    window.addEventListener("scroll", save, { passive: true });
    window.addEventListener("wheel", stop, { passive: true });
    window.addEventListener("touchstart", stop, { passive: true });
    window.addEventListener("keydown", stop);
    return () => {
      cancelAnimationFrame(frame); stop();
      positions.current.set(key, window.scrollY);
      if (positions.current.size > 100) positions.current.delete(positions.current.keys().next().value!);
      window.removeEventListener("scroll", save);
      window.removeEventListener("wheel", stop);
      window.removeEventListener("touchstart", stop);
      window.removeEventListener("keydown", stop);
    };
  }, [location.key, navigationType]);
  useEffect(() => {
    const previous = history.scrollRestoration;
    history.scrollRestoration = "manual";
    return () => { history.scrollRestoration = previous; };
  }, []);
  return null;
}
